import { computed, defineComponent } from "@vue/composition-api";
import SummarySectionLayout from "./summary-section-layout.vue";
import { useLiabilityHelpers } from "@Client/@Composables/application-standalone/pages/liabilities/useLiabilityHelpers";
export default defineComponent({
  name: "LiabilitiesSection",
  components: {
    SummarySectionLayout
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      liabilitySummarySubtitle,
      applicantHasLiabilities,
      isLiabilitySectionVisibleForMainApplicant,
      isLiabilitySectionVisibleForCoApplicants
    } = useLiabilityHelpers();
    const sectionVisibilityValues = computed(() => ({
      mainApplicant: isLiabilitySectionVisibleForMainApplicant.value,
      coApplicants: isLiabilitySectionVisibleForCoApplicants.value
    }));
    return {
      liabilitySummarySubtitle,
      applicantHasLiabilities,
      sectionVisibilityValues
    };
  }
});